/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Recycle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M236.76758,203.98145a23.75493,23.75493,0,0,1-20.791,12.01074H160V232a8.00052,8.00052,0,0,1-13.6582,5.65625l-24-24.00781a8.0018,8.0018,0,0,1,.00195-11.31446l24-23.99218A8.00042,8.00042,0,0,1,160,184v15.99219h55.97656a8.00079,8.00079,0,0,0,6.92383-12.00781l-23.95117-41.37793a8.00013,8.00013,0,1,1,13.84766-8.01563l23.95117,41.37793A23.75534,23.75534,0,0,1,236.76758,203.98145ZM88,199.99219H40.02344a8.00079,8.00079,0,0,1-6.92383-12.00781L61.062,139.67554l13.894,8.02173a7.99907,7.99907,0,0,0,11.72657-9l-8.792-32.78907a7.99883,7.99883,0,0,0-9.79882-5.65429L35.31445,109.043a7.99934,7.99934,0,0,0-1.92773,14.6543l13.81836,7.978L19.252,179.96875a24.00019,24.00019,0,0,0,20.77149,36.02344H88a8,8,0,0,0,0-16ZM128,32a7.86145,7.86145,0,0,1,6.92383,3.99219l27.95361,48.2937-13.81982,7.97876a7.9999,7.9999,0,0,0,1.92871,14.65527l32.77832,8.78809a7.99309,7.99309,0,0,0,9.79883-5.65625l8.791-32.78809a8,8,0,0,0-11.72754-8.999l-13.89306,8.021L148.77148,27.97656a24.00073,24.00073,0,0,0-41.543,0L83.27832,69.35449A8.00013,8.00013,0,0,0,97.126,77.37012l23.95019-41.37793A7.86145,7.86145,0,0,1,128,32Z" />
    </Svg>
  );
}

export default Recycle;
